<nav class="px-0 mt-4 shadow-lg">
  <form class="form" [formGroup]="Form" (ngSubmit)="onSubmit()">
    <div class="input-group mb-3">
      <input type="text" required formControlName="terms" class="form-control form-control-lg" placeholder="Search for IP, Domain, Hash, Registry, Filename ..."
        autofocus aria-label="Example text with button addon" aria-describedby="button-addon1" style="border-radius:0px;">
      <div class="input-group-append">
        <button class="btn btn-outline-primary btn-lg font-textmeone"  type="submit" [disabled]="Form.invalid" id="button-addon1" style="border-radius:0px;border-color:#ced4da;"><i
            class="fas fa-search"></i>&nbsp;Search</button>
      </div>
    </div>
  </form>
</nav>
